// 「会员更新」入口落点：已签约自动更新（bind=true）→ 自动更新页；否则 → 更新选项页。
// 与 china-club-web 的 pages-ecards/applications/renewal/renewal-entry.js 保持一致。
export const RENEWAL_ENTRY_ROUTES = {
  member: { options: '/renewal_options', auto: '/auto_renew' },
  store: { options: '/renewal_options_store', auto: '/auto_renew_store' },
}

export const resolveRenewalEntryRoute = (autoRenewData, accountType = 'member') => {
  const routes = RENEWAL_ENTRY_ROUTES[accountType === 'store' ? 'store' : 'member']
  return autoRenewData && autoRenewData.bind ? routes.auto : routes.options
}
